import { CmsProduct } from '../../../types/cmsProduct';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import type { ResolvedGroup } from '../utils/resolveAttributeRow/resolveAttributeRow';
import { ProductDetailsAttributeGroupBody } from './ProductDetailsAttributeGroupBody';
import { ProductDetailsSectionWrapper } from './ProductDetailsSectionWrapper';

type ProductDetailsAttributeGroupsProps = {
  groups: ResolvedGroup[];
  /** Section title — the analytics section title of every group and row. */
  sectionTitle: string;
  product?: CmsProduct;
  pushDataLayer?: PushDataLayerFn;
};

/**
 * Resolved attribute groups of a section, without its header. A group with a title renders as an
 * accordion when `collapsible`, otherwise as a captioned plain card; an untitled group is a plain
 * card. The section title is the analytics section title of every group and row, as in the default
 * sections.
 */
export const ProductDetailsAttributeGroups: React.FC<
  ProductDetailsAttributeGroupsProps
> = ({ groups, sectionTitle, product, pushDataLayer }) => (
  <>
    {groups.map((group) => (
      <ProductDetailsSectionWrapper
        key={group.id}
        // An accordion needs its title as the toggle's accessible name; a title-less
        // group falls back to a plain card even when the editor ticked `collapsible`.
        dropdownSection={group.collapsible && Boolean(group.title)}
        title={group.title}
        sectionTitle={sectionTitle}
        product={product}
        pushDataLayer={pushDataLayer}
      >
        <ProductDetailsAttributeGroupBody
          group={group}
          sectionTitle={sectionTitle}
          product={product}
          pushDataLayer={pushDataLayer}
        />
      </ProductDetailsSectionWrapper>
    ))}
  </>
);
